import Header from "./Components/Header/Header";
import Main from "./Components/Main/Main";
import Footer from "./Components/Footer/Footer";
import Material from "./Components/Material/Material";
import Pricelist from "./Components/Pricelist/Pricelist";

function App() {
  return (
    <div className="page">
      <Header/>
      <Main/>
      <Pricelist/>
      <Material/>
      <Footer/>
    </div>
  );
}

export default App;
